const gigNegotiations = [
	{
		path: '/jobs/gig-negotiations/list',
		name: 'jobs-gig-negotiations-list',
		component: () => import('@/views/jobs/gig-negotiations/list.vue'),
		meta: { layout: 'content', module: 'MGJ,gigs' },
	},
]

export default gigNegotiations
